
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportDailyCNDialog extends Serenity.EntityDialog<ReportDailyCNRow, any> {
        protected getFormKey() { return ReportDailyCNForm.formKey; }
        protected getIdProperty() { return ReportDailyCNRow.idProperty; }
        protected getLocalTextPrefix() { return ReportDailyCNRow.localTextPrefix; }
        protected getNameProperty() { return ReportDailyCNRow.nameProperty; }
        protected getService() { return ReportDailyCNService.baseUrl; }
        protected getDeletePermission() { return ReportDailyCNRow.deletePermission; }
        protected getInsertPermission() { return ReportDailyCNRow.insertPermission; }
        protected getUpdatePermission() { return ReportDailyCNRow.updatePermission; }

        protected form = new ReportDailyCNForm(this.idPrefix);

    }
}